import React from 'react';
import { ArrowUpRightIcon, DownloadIcon } from 'lucide-react';
import { Stars } from './GoogleReviews';
import type { Project } from '../data/projects';
type ProjectReviewCardProps = {
  project: Project;
};
export function ProjectReviewCard({
  project
}: ProjectReviewCardProps) {
  return <article className="flex h-full flex-col rounded-[12px] border border-white/[0.08] bg-white/[0.04] p-7 md:p-10" data-id="element-434" data-mp="1avpxyuxnqowy">
      <div className="flex items-center justify-between gap-4" data-id="element-435" data-mp="1ymvdf8zorf6q">
        <p className="truncate text-[14px] text-white/50" data-id="element-436" data-mp="23knf2uq4ufo4">{project.title}</p>
        <span className="shrink-0" role="img" aria-label={`${project.rating} von 5 Sternen`} data-id="element-437" data-mp="23mzxf8zsys1p">
          <Stars value={project.rating} data-id="element-438" data-mp="1otxzlg5n2eeg" />
        </span>
      </div>

      <blockquote className="mt-6 font-display text-[20px] leading-[1.35] tracking-[-0.02em] text-white md:text-[24px]" data-id="element-439" data-mp="1ttsrnn15ha13">
        „{project.review}“
      </blockquote>

      <div className="mt-6 flex items-center gap-3" data-id="element-440" data-mp="2mby416casidd">
        {project.avatar ? <img src={project.avatar} alt="" draggable={false} className="h-10 w-10 shrink-0 rounded-full object-cover" data-id="element-441" data-mp="24irmrfxkeaj6" /> : <span aria-hidden="true" className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#5f6b7a] text-[16px] font-medium text-white" data-id="element-442" data-mp="2e8kw0aa8idk9">
            {project.authorName.charAt(0)}
          </span>}
        <div className="min-w-0" data-id="element-443" data-mp="2n7y5h2ycz24z">
          <p className="truncate text-[15px] font-medium leading-tight text-white/90" data-id="element-444" data-mp="2nb2j0qxpra8b">{project.authorName}</p>
          <p className="truncate text-[13px] leading-tight text-white/50" data-id="element-445" data-mp="2x7f9zh1vj9zd">{project.clientName}</p>
        </div>
      </div>
      <p className="mt-4 text-[13px] text-white/45" data-id="element-446" data-mp="2s7t11jt2wfwd">{project.details.join(' · ')}</p>

      <div className="mt-auto flex flex-wrap items-center gap-x-6 gap-y-3 pt-10 text-[14px]" data-id="element-447" data-mp="12t4kr7hdadt2">
        <a href={project.reviewUrl} className="inline-flex items-center gap-1.5 text-white transition-colors duration-150 hover:text-white/70" data-id="element-448" data-mp="xukyt72rx20p">
          Bewertung lesen
          <ArrowUpRightIcon className="h-4 w-4" data-id="element-449" data-mp="1rjsgat67r8k5" />
        </a>
        <a href={project.downloadUrl} download className="inline-flex items-center gap-1.5 text-white/50 transition-colors duration-150 hover:text-white" data-id="element-450" data-mp="1rkc06fffc70t">
          <DownloadIcon className="h-4 w-4" data-id="element-451" data-mp="21jszmf431ooc" />
          Projektdaten
        </a>
      </div>
    </article>;
}